/* ============================================================
   hoh-contract-debug.js — jangela's secret Contract test kit
   FramedFantasy Hall of Heroes

   A floating panel that appears ONLY when hohIsGodMode() is true, on
   any device. It drives the god-mode local test mode in
   hoh-contract-data.js (window.HOHContractData.debug): play the whole
   Contract client-side with no RPCs, no settle worker, and no daily
   lock, and force the outcomes you want to see.

   Nothing here runs for a normal player: the body is gated on god
   mode and everything is wrapped in try/catch so it can never break
   the Hall. It also flips window.HOH_CONTRACT_ENABLED on while god
   mode is active, so the event is testable with the section toggle
   still off in the theme editor.
   ============================================================ */
(function () {
  'use strict';
  if (window.__hohContractDebugInstalled) return;
  window.__hohContractDebugInstalled = true;

  var PANEL_ID = 'hoh-contract-debug';
  var newPlayerBusy = false;
  var YMD = function () { try { return new Date().toISOString().slice(0, 10); } catch (e) { return ''; } };
  var MILES = [10, 20, 30, 40, 50, 60];

  function god() { try { return typeof window.hohIsGodMode === 'function' && window.hohIsGodMode(); } catch (e) { return false; } }
  function D() { return (window.HOHContractData && window.HOHContractData.debug) || null; }
  function repaintQuest() { try { if (typeof window.hohPaintQuestProgress === 'function') window.hohPaintQuestProgress(); } catch (e) {} }
  function flash(msg) {
    var el = document.getElementById('hoh-contract-debug-msg'); if (!el) return;
    el.textContent = msg; el.style.opacity = '1';
    clearTimeout(el.__t); el.__t = setTimeout(function () { el.style.opacity = '.45'; }, 1400);
  }

  /* ---- actions ---- */
  function completeDaily() {
    try {
      var d = YMD();
      MILES.forEach(function (n) { localStorage.setItem('hoh-ff-claim-' + d + '-' + n, '1'); });
      localStorage.setItem('hoh-ff-hearts-' + d, '60');
    } catch (e) {}
    repaintQuest(); flash('Explore daily completed');
  }
  function resetDaily() {
    try {
      var d = YMD();
      MILES.forEach(function (n) { localStorage.removeItem('hoh-ff-claim-' + d + '-' + n); });
      localStorage.removeItem('hoh-ff-hearts-' + d);
    } catch (e) {}
    repaintQuest(); flash('Explore daily reset');
  }
  function resetContractDay() { var d = D(); if (d) d.resetDay(); repaintQuest(); flash('Contract day reset (playable again)'); }
  function grant(n) { var d = D(); if (d) d.grantHearts(n); flash('+' + n + ' hearts'); render(); }
  function playNow() {
    completeDaily();
    setTimeout(function () {
      try { if (window.hohContractUnlock) window.hohContractUnlock(); } catch (e) {}
      var host = document.getElementById('hoh-contract');
      if (host && host.scrollIntoView) { try { host.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {} }
    }, 60);
    flash('Herald opened');
  }

  /* ---- cycles for the force flags ---- */
  function cycleRaise() {
    var d = D(); if (!d) return;
    var cur = d.getForce().raise;
    var next = cur === undefined ? true : cur === true ? false : undefined; /* Auto -> Raise -> No -> Auto */
    d.setForce({ raise: next === undefined ? null : next });
    render(); flash('Raise: ' + (next === undefined ? 'auto' : next ? 'forced' : 'never'));
  }
  function cycleOutcome() {
    var d = D(); if (!d) return;
    var cur = d.getForce().outcome;
    var next = !cur ? 'win' : cur === 'win' ? 'loss' : null;                 /* Auto -> Win -> Loss -> Auto */
    d.setForce({ outcome: next });
    render(); flash('Outcome: ' + (next || 'auto'));
  }
  function toggleFast() { var d = D(); if (!d) return; var on = !d.getForce().fast; d.setForce({ fast: on ? true : null }); render(); flash('Fast playback ' + (on ? 'on' : 'off')); }
  function toggleNewPlayerPreview() {
    var d = D();
    if (!d || !d.setNewPlayerPreview || newPlayerBusy) return;
    var on = !(d.isNewPlayerPreview && d.isNewPlayerPreview());
    newPlayerBusy = true; render(); flash('Switching view…');
    Promise.resolve(d.setNewPlayerPreview(on)).then(function (result) {
      newPlayerBusy = false; render();
      if (!result || result.ok !== true) {
        var reason = result && result.reason;
        flash(reason === 'active_run' ? 'Finish or end the current run first.' :
          reason === 'settlement_pending' ? 'Let the current result finish saving first.' :
          'The new-player preview could not open.');
        return;
      }
      try {
        if (window.HOHContractUI && window.HOHContractUI.debugRestartUnlimited) {
          window.HOHContractUI.debugRestartUnlimited(on);
        }
      } catch (_) {}
      flash(on ? '1-slot preview on · real progress is safe' : 'Live quest progress restored');
    })['catch'](function () {
      newPlayerBusy = false; render(); flash('The new-player preview could not switch.');
    });
  }

  /* ---- render ---- */
  function btn(label, id, on) {
    return '<button type="button" data-act="' + id + '" class="hcd-btn' + (on ? ' hcd-on' : '') + '">' + label + '</button>';
  }
  function render() {
    var panel = document.getElementById(PANEL_ID); if (!panel) return;
    var d = D();
    var f = d ? d.getForce() : {};
    var local = d ? d.isLocal() : false;
    var newPlayer = !!(d && d.isNewPlayerPreview && d.isNewPlayerPreview());
    var bank = 0; try { bank = (window.HOHContractData && window.HOHContractData.bankGet && window.HOHContractData.bankGet()) || 0; } catch (e) {}
    var raiseLbl = f.raise === true ? 'Raise: forced' : f.raise === false ? 'Raise: never' : 'Raise: auto';
    var outLbl = f.outcome === 'win' ? 'Outcome: win' : f.outcome === 'loss' ? 'Outcome: loss' : 'Outcome: auto';
    var lockLeft = 0; try { lockLeft = (d && d.lockMsLeft) ? d.lockMsLeft() : 0; } catch (e) {}
    var lockLbl = lockLeft > 0
      ? 'Skip lockout · ' + Math.floor(lockLeft / 60000) + ':' + ('0' + Math.floor((lockLeft % 60000) / 1000)).slice(-2)
      : 'Lockout: clear';
    var body = panel.querySelector('.hcd-body'); if (!body) return;
    body.innerHTML =
      /* R410 (Jan): "god mode should have the same experience as normal
         people". The Local test switch is gone. God mode is not a mode any
         more, it plays the live game, so the only thing left to say here is
         where this run will actually be judged. The browser judge line only
         appears when you are signed out, which is the one case it can still
         happen and the one case you need to know about. */
      '<div class="hcd-row hcd-stat">bank ' + bank + ' ♥ · ' +
        (newPlayer ? 'NEW PLAYER PREVIEW · local only · nothing is saved' :
          local ? 'SIGNED OUT · judged in this browser · nothing is saved' : 'live server') + '</div>' +
      '<div class="hcd-row">' + btn('Play now', 'play', false) + btn('+300 ♥', 'grant', false) + '</div>' +
      '<div class="hcd-row">' + btn(newPlayerBusy ? 'Switching…' :
        (newPlayer ? 'Exit 1-slot preview' : 'Preview new player · 1 slot'), 'newplayer', newPlayer) + '</div>' +
      '<div class="hcd-row">' + btn('Complete daily', 'complete', false) + btn('Reset daily', 'resetd', false) + '</div>' +
      '<div class="hcd-row">' + btn('Play again (reset day)', 'resetc', false) + '</div>' +
      '<div class="hcd-row">' + btn(raiseLbl, 'raise', f.raise !== undefined) + btn(outLbl, 'outcome', !!f.outcome) + '</div>' +
      '<div class="hcd-row">' + btn(f.fast ? 'Fast: on' : 'Fast: off', 'fast', !!f.fast) + '</div>' +
      /* R337: skip the loss cooling-off. Labelled with the time remaining so
         it reads as a state, not a mystery button, and disabled-looking when
         there is nothing to skip. */
      '<div class="hcd-row">' + btn(lockLbl, 'unlock', lockLeft > 0) + '</div>' +
      /* ============ R450 THE MASTER MAP ============
         The creator's per-stage readout and the sandbox preview. Reads
         are pure engine calls, the preview is a local E.run — no RPC, no
         settle, no ladder write, so it CANNOT touch progress, the high
         water mark or the economy by construction (wave2b's admin
         corruption control). Bot-measured clear rates live in
         harness/out/bot-v47.json in the repo, refreshed by
         `node harness/bot.cjs` — they are a build tool, not a shipped
         asset, so this panel names them instead of embedding them. */
      '<div class="hcd-row"><input id="hcdStage" type="number" min="1" max="200" value="' + (window.__hcdStage || 21) + '" style="flex:1;min-height:36px;background:#12101a;border:1px solid #322a44;border-radius:7px;color:#cfc7b8;padding:0 8px;font-size:12px" aria-label="Stage number">' +
        btn('Read stage', 'mapread', false) + btn('Preview', 'mapprev', false) + '</div>' +
      /* R450b: Jan's playtest door. Server-side hoh_bg_admin_jump refuses
         every account but the owner's; in the signed-out sandbox it just
         moves the local stage. Reuses the stage box above. */
      '<div class="hcd-row">' + btn('Jump to stage', 'mapjump', false) + '</div>' +
      '<div class="hcd-map" id="hcdMap" style="font-size:10.5px;line-height:1.5;color:#b8b0c4;max-height:190px;overflow:auto"></div>' +
      '<div class="hcd-msg" id="hoh-contract-debug-msg"></div>';
  }
  /* R450: the map actions. The seed is the LIVE run's when one is open
     (so the readout matches the fight on screen) and a fixed preview
     seed otherwise, printed so two readings compare like for like. */
  function _mapSeed() {
    try {
      var ui = window.HOHContractUI;
      if (ui && ui.state && ui.state() && ui.state().run && ui.state().run.seed) return String(ui.state().run.seed);
    } catch (e) {}
    return 'a3f1c2d4e5b697a8b9c0d1e2f3a4b5c6';
  }
  function mapRead() {
    var E = window.HOHContract; if (!E) { flash('engine not loaded'); return; }
    var el = document.getElementById('hcdMap'); if (!el) return;
    var st = Math.max(1, +((document.getElementById('hcdStage') || {}).value || 21));
    window.__hcdStage = st;
    var seed = _mapSeed();
    var out = [];
    try {
      var kind = E.ladderKind(st);
      out.push('<b>Stage ' + st + '</b> · ' + kind + ' · seed ' + seed.slice(0, 8));
      var ar = E.ladderArena && E.ladderArena(st);
      if (ar) out.push('arena: ' + ar.name + ' — ' + ar.text);
      var mu = E.ladderMutator && E.ladderMutator(st, seed);
      if (mu) out.push('mutator: ' + mu.name + ' — ' + mu.text);
      var oi = E.ladderOptIn && E.ladderOptIn(st, seed);
      if (oi) out.push('opt-in: ' + oi.name + ' (' + oi.reward + ')');
      var evd = E.eventFor && E.eventFor(st, seed);
      if (evd) out.push('event: ' + evd.name + (evd.beat ? ' beat ' + evd.beat : '') + ' [' + evd.arch + ']');
      var au = E.PATH_STAGES && E.PATH_STAGES[st];
      if (au && au.teach) out.push('teach: ' + au.teach);
      var bd = E.ladderFoe && E.ladderFoe(st, seed);
      if (bd && bd.kind !== 'shop') {
        out.push('board: ' + bd.foe.length + ' bodies + ' + bd.bench.length + ' bench · pool ' + bd.pool + ' · stat ' + (Math.round(bd.stat * 100) / 100));
        /* R661: the version is an argument (R654). This panel reads a stage
           the live engine would field, so it names the live engine's die. */
        out.push(bd.foe.map(function (f) { return f.cls + ' d' + (E.dieOf ? E.dieOf(f, E.ENGINE_VERSION | 0) : '?') + (f.vet ? ' ▲' : ''); }).join(', '));
      }
      var dr = E.draftOffer && E.draftOffer(st, seed);
      if (dr && dr.length) out.push('draft: ' + dr.join(' / '));
    } catch (e) { out.push('read failed: ' + (e && e.message)); }
    el.innerHTML = out.join('<br>');
    flash('stage read, no writes');
  }
  function mapPreview() {
    var E = window.HOHContract; if (!E) { flash('engine not loaded'); return; }
    var el = document.getElementById('hcdMap'); if (!el) return;
    var st = Math.max(1, +((document.getElementById('hcdStage') || {}).value || 21));
    var seed = _mapSeed();
    /* a fixed benchmark five, the harness MID party's shape */
    var party = [
      { name: 'M-FIGHTER', cls: 'Fighter', rar: 3, lvl: 50, hearts: 300, skill: { id: 'rampart', r: 3 }, passive: { id: 'ironresolve', r: 2 } },
      { name: 'M-CLERIC', cls: 'Cleric', rar: 3, lvl: 50, hearts: 300, skill: { id: 'triage', r: 2 }, passive: { id: 'clarity', r: 2 } },
      { name: 'M-WIZARD', cls: 'Wizard', rar: 4, lvl: 50, hearts: 600, skill: { id: 'glassedge', r: 3 }, passive: { id: 'focus', r: 2 } },
      { name: 'M-BARB', cls: 'Barbarian', rar: 3, lvl: 50, hearts: 300, skill: { id: 'momentum', r: 2 }, passive: { id: 'adrenaline', r: 2 } },
      { name: 'M-BARD', cls: 'Bard', rar: 3, lvl: 50, hearts: 300, skill: { id: 'crescendo', r: 2 }, passive: { id: 'standingova', r: 2 } }
    ];
    try {
      /* R456: card ids are party slots now (c0..c4); 'csig' would be refused
         by readPlays and the preview would silently measure a no-card fight */
      var res = E.run({ seed: seed, roster: party, stage: st, carryA: 0, champ: 2, plays: [{ id: 'c2', atA: 2 }] });
      var paths = res.events.filter(function (x) { return x.e === 'path'; }).map(function (x) { return x.kind + ':' + x.id; });
      el.innerHTML = '<b>Preview · stage ' + st + '</b> · winner ' + res.winner + ' in ' + res.rounds + ' rounds · ' +
        res.ta + ' vs ' + res.tb + '<br>' + (paths.length ? paths.join(' · ') + '<br>' : '') +
        res.events.length + ' events · sandbox only, nothing written';
    } catch (e) { el.innerHTML = 'preview failed: ' + (e && e.message); }
    flash('previewed, no writes');
  }

  function clearLockout() {
    var d = D();
    if (!d || !d.clearLock) { flash('no lock api'); return; }
    try { d.clearLock(); } catch (e) {}
    flash('gates open');
    render();
    /* repaint the herald so the Battle button comes back without a reload */
    try { if (window.HOHContractUI && window.HOHContractUI.refresh) window.HOHContractUI.refresh(); } catch (e) {}
  }
  /* R450b: the stage jump. The one debug act that WRITES ladder state, so
     it says exactly what happened and repaints the herald. The server owns
     the guard (owner email only); everyone else reads a plain refusal. */
  function mapJump() {
    var DD = window.HOHContractData;
    if (!DD || !DD.adminJump) { flash('no jump api'); return; }
    var st = Math.max(1, +((document.getElementById('hcdStage') || {}).value || 1));
    window.__hcdStage = st;
    DD.adminJump(st).then(function (r) {
      if (r && r.ok === true) {
        flash('standing on stage ' + (r.stage | 0) + ' · enter from the herald');
        try { if (window.HOHContractUI && window.HOHContractUI.refresh) window.HOHContractUI.refresh(); } catch (e) {}
      } else {
        flash('refused: ' + ((r && r.reason) || 'not the owner'));
      }
    })['catch'](function (e) { flash('jump failed: ' + ((e && e.message) || 'network')); });
  }
  var ACTS = { play: playNow, grant: function () { grant(300); }, complete: completeDaily, resetd: resetDaily, resetc: resetContractDay, newplayer: toggleNewPlayerPreview, raise: cycleRaise, outcome: cycleOutcome, fast: toggleFast, unlock: clearLockout, mapread: mapRead, mapprev: mapPreview, mapjump: mapJump };

  function mount() {
    if (document.getElementById(PANEL_ID)) { render(); return; }
    /* make the whole event testable with the section flag still off */
    try { window.HOH_CONTRACT_ENABLED = true; } catch (e) {}
    ensureCss();
    var panel = document.createElement('div');
    panel.id = PANEL_ID;
    panel.className = 'hcd-collapsed';
    panel.innerHTML =
      '<div class="hcd-head"><span class="hcd-title">⚙ Battlegrounds debug</span>' +
      '<button type="button" class="hcd-toggle" aria-label="Toggle">–</button></div>' +
      '<div class="hcd-body"></div>';
    document.body.appendChild(panel);
    panel.querySelector('.hcd-head').addEventListener('click', function (e) {
      if (e.target && e.target.getAttribute('data-act')) return;
      panel.classList.toggle('hcd-collapsed');
    });
    panel.addEventListener('click', function (e) {
      var a = e.target && e.target.getAttribute && e.target.getAttribute('data-act');
      if (!a || !ACTS[a]) return;
      e.stopPropagation();
      try { ACTS[a](); } catch (err) {}
    });
    render();
  }
  function unmount() { var p = document.getElementById(PANEL_ID); if (p) p.remove(); }

  /* ---- R334: the overlay is now OPT-IN from the master debug panel ----
     This panel used to mount itself the moment god mode was on, so it sat
     over the bottom-left corner of every screen forever — including the
     Battlegrounds screens it exists to test, where it covered the party grid
     in Jan's screenshots. It is one switch inside the main DEBUG panel now
     (Battle tab). The flag is persisted so it stays off across reloads, and
     god mode is still an absolute precondition: flipping the key by hand on
     a normal account does nothing. */
  var SHOW_KEY = 'hoh-contract-debug-on';
  function wanted() {
    try { return localStorage.getItem(SHOW_KEY) === '1'; } catch (e) { return false; }
  }
  function setWanted(on) {
    try { localStorage.setItem(SHOW_KEY, on ? '1' : '0'); } catch (e) {}
    sync();
  }
  function sync() {
    var isGod = god();
    /* mount() used to be the only thing that set this, so hiding the panel
       by default would have quietly taken the Battlegrounds away from god
       mode when the section flag is off. It belongs to god mode, not to the
       panel, so it is set here instead. */
    if (isGod) { try { window.HOH_CONTRACT_ENABLED = true; } catch (e) {} }
    if (isGod && wanted()) mount(); else unmount();
  }

  /* the master panel drives it through this handle */
  window.hohContractDebugPanel = {
    isOn: function () { return god() && wanted(); },
    set: setWanted,
    toggle: function () { setWanted(!wanted()); return wanted(); }
  };

  function ensureCss() {
    if (document.getElementById('hcd-css')) return;
    var css = [
      '#' + PANEL_ID + '{position:fixed;left:12px;bottom:12px;z-index:999997;width:230px;max-width:calc(100vw - 24px);',
      'background:#0b0a10;border:1px solid #3a2f1a;border-radius:12px;color:#e8e0d0;font-family:system-ui,-apple-system,sans-serif;',
      'box-shadow:0 10px 30px rgba(0,0,0,.5);overflow:hidden}',
      '#' + PANEL_ID + ' .hcd-head{display:flex;align-items:center;justify-content:space-between;gap:8px;padding:9px 11px;cursor:pointer;background:linear-gradient(180deg,#171019,#0b0a10);border-bottom:1px solid #241c10}',
      '#' + PANEL_ID + ' .hcd-title{font-size:11px;letter-spacing:1.5px;text-transform:uppercase;color:#c9a84c}',
      '#' + PANEL_ID + ' .hcd-toggle{background:none;border:none;color:#8a8090;font-size:16px;line-height:1;cursor:pointer;padding:0 4px}',
      '#' + PANEL_ID + '.hcd-collapsed .hcd-body{display:none}',
      /* ⛔ R609 · z-index 999997 is TEN TIMES the Hall's dialog layer, so this
         kit painted on top of the hero form, the detail card and the raffle.
         Jan's Edit Your Hero screenshot has it sitting on the submission
         rules. It steps out while one of those three dialogs is up; the
         Battlegrounds screens it exists to test are not viewport modals, so
         nothing it is actually for is affected. The Hall's own
         "hide all debug until refresh" switch is the wider off switch. */
      'body.hoh-viewport-modal-open #' + PANEL_ID + '{display:none}',
      'body.hoh-debug-off #' + PANEL_ID + '{display:none}',
      '#' + PANEL_ID + ' .hcd-body{padding:9px}',
      '#' + PANEL_ID + ' .hcd-row{display:flex;gap:6px;margin-bottom:6px}',
      '#' + PANEL_ID + ' .hcd-stat{font-size:10px;letter-spacing:.5px;color:#8a8090;text-transform:uppercase;margin-bottom:8px}',
      '#' + PANEL_ID + ' .hcd-btn{flex:1;min-height:36px;padding:8px 9px;border:1px solid #322a44;border-radius:7px;background:#12101a;color:#cfc7b8;font-size:11px;cursor:pointer;line-height:1.15}',
      '#' + PANEL_ID + ' .hcd-btn:hover{border-color:#c9a84c}',
      '#' + PANEL_ID + ' .hcd-btn.hcd-on{background:linear-gradient(135deg,#c9a84c,#a8893a);color:#0a0a0f;border-color:#c9a84c;font-weight:700}',
      '#' + PANEL_ID + ' .hcd-msg{min-height:14px;font-size:10.5px;font-style:italic;color:#7ec4cf;opacity:.45;transition:opacity .2s;margin-top:2px}'
    ].join('');
    var s = document.createElement('style'); s.id = 'hcd-css'; s.textContent = css; document.head.appendChild(s);
  }

  document.addEventListener('hoh:god-mode-changed', sync);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();
  /* god mode can flip via console after load; a slow poll catches it.
     R318: was a 4s wakeup for EVERY visitor forever — the god-mode-changed
     event above already covers the normal path, so 15s and skip hidden tabs. */
  setInterval(function () { if (!document.hidden) sync(); }, 15000);
})();
